import { formatDamNotesForDriver } from '../../utils/utils';
import { stripSocTierLinesFromNotes } from '../../utils/socDynamicPriceNotes';

const WEBCAM_MARKER_BADGE_HTML =
  '<span class="cluster-marker__camera-label" title="Webcam" aria-hidden="true">' +
  '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
  '<path d="M17 10.5V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3.5l5 3.5V7l-5 3.5z"/>' +
  '</svg></span>';

const SOLAR_MARKER_BADGE_HTML =
  '<span class="cluster-marker__solar-label" title="Solar & storage" aria-hidden="true">' +
  '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
  '<circle cx="12" cy="12" r="4"/>' +
  '<path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>' +
  '</svg></span>';

export function escapeEmbedHtml(text) {
  return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

export function formatEmbedPortPriceLabel(costPerKwt, unit) {
  if (costPerKwt == null || costPerKwt === undefined) {
    return '';
  }
  const price = Number((Number(costPerKwt) / 100).toFixed(2));
  if (!Number.isFinite(price)) {
    return '';
  }
  return `${price} ${unit}`;
}

export function resolveEmbedPortNotes(firstPort) {
  if (!firstPort) {
    return '';
  }
  const lang = (localStorage.getItem('i18nextLng') || 'ua').split('-')[0];
  const preferUa = lang !== 'en';
  const notesRaw = (preferUa ? firstPort?.notesUa : firstPort?.notesEn) || firstPort?.notesUa || '';
  const notesForUser = stripSocTierLinesFromNotes(notesRaw);
  if (!notesForUser.trim()) {
    return '';
  }
  return formatDamNotesForDriver(notesForUser, preferUa);
}

export function buildEmbedPortClusterRowsHtml({
  ports,
  statuses,
  plugTypeMap,
  getConnectorNum,
  getStatusClass,
  priceUnit,
  selectedNumber = null,
}) {
  return ports
    .map((port, index) => {
      const connectorNum = getConnectorNum(port, index);
      const plugLabel = plugTypeMap[port?.plugType] || port?.plugType || '';
      const liveStatus = statuses[String(port?.number)];
      const statusClass = getStatusClass(port, liveStatus);
      const selected =
        selectedNumber != null && String(port?.number) === String(selectedNumber)
          ? ' embed-port-cluster__row--selected'
          : '';
      const priceLabel = formatEmbedPortPriceLabel(port?.costPerKwt, priceUnit);
      const priceHtml = priceLabel
        ? `<span class="embed-port-cluster__price">${escapeEmbedHtml(priceLabel)}</span>`
        : '';
      return `<div class="embed-port-cluster__row ${statusClass}${selected}"><span class="embed-port-cluster__num">${escapeEmbedHtml(connectorNum)}</span><span class="embed-port-cluster__type">${escapeEmbedHtml(plugLabel)}</span>${priceHtml}</div>`;
    })
    .join('');
}

export function wrapEmbedClusterWithFeatureBadges(clusterEl, { hasWebcam, hasEnergyStorage }) {
  if (!hasWebcam && !hasEnergyStorage) {
    return clusterEl;
  }

  const shell = document.createElement('div');
  shell.className = 'cluster-marker-shell embed-port-cluster-badge-shell';
  if (hasWebcam) {
    shell.classList.add('cluster-marker-shell--has-webcam');
  }
  if (hasEnergyStorage) {
    shell.classList.add('cluster-marker-shell--has-solar');
  }

  const frame = document.createElement('div');
  frame.className = 'cluster-marker-shell__frame';
  frame.appendChild(clusterEl);

  if (hasEnergyStorage) {
    frame.insertAdjacentHTML('beforeend', SOLAR_MARKER_BADGE_HTML);
  }
  if (hasWebcam) {
    frame.insertAdjacentHTML('beforeend', WEBCAM_MARKER_BADGE_HTML);
  }

  shell.appendChild(frame);
  return shell;
}
